import Vue from "vue";

Vue.component("LeadTop", () => import("./LeadTop.vue"));
Vue.component("CurrentLead", () => import("./CurrentLead.vue"));
Vue.component("LeadPendingList", () => import("./LeadPendingList.vue"));
Vue.component("LeadInAttendenceList", () =>
  import("./LeadInAttendenceList.vue")
);
Vue.component("NextLeads", () => import("./NextLeads.vue"));
